import Logo from "~/components/Logo";
import { Button } from "~/components/ui/button";
import Content from "~/components/Content";
import { Icon } from "@iconify/react";
import { scrollToElement } from "~/utils.client";
import ThemeToggleButton from "~/components/ThemeToggleButton";
import { Link } from "@remix-run/react";

export default function NavbarPrivacyPolicy() {
  return (
    <header className="py-4 md:py-6 lg:py-12 bg-background">
      <Content>
        <div className="flex justify-between">
          <div className="flex items-center gap-16">
            <Link to="/">
              <Logo className="h-6 md:h-8 w-auto" />
            </Link>
          </div>
          <div className="flex justify-center items-center">
            <Button className="gap-2 text-lg" variant="ghost" asChild>
              <Link to="/">
                Tillbaka
                <Icon
                  className="h-8 w-fit"
                  icon="material-symbols-light:arrow-left-alt"
                />
              </Link>
            </Button>
          </div>
          <div className="flex justify-end items-center gap-8">
            <p className="hidden md:block font-light">Vill du veta mer?</p>
            <Button
              className="hidden md:block"
              onClick={() => scrollToElement("contact")}
            >
              Kontakta oss
            </Button>
            <ThemeToggleButton />
          </div>
        </div>
      </Content>
    </header>
  );
}
